import type { Camera } from "../engine/Camera.ts";
import type { SceneGraph } from "../engine/types.ts";

export interface MinimapCallbacks { onJump: (wx: number, wy: number) => void; }

/** Minimapa: visão geral do universo + retângulo do viewport; clique para voar até lá. */
export class Minimap {
  private canvas!: HTMLCanvasElement;
  private ctx!: CanvasRenderingContext2D;
  private W = 190; private H = 132;
  private dpr = Math.min(2, window.devicePixelRatio || 1);
  private color: (g: string) => number = () => 0xffffff;
  private span = 1;

  constructor(private cb: MinimapCallbacks) {}
  setColor(fn: (g: string) => number) { this.color = fn; }

  mount(root: HTMLElement) {
    root.insertAdjacentHTML("beforeend", `<div id="minimap" class="panel"><canvas></canvas></div>`);
    this.canvas = root.querySelector("#minimap canvas") as HTMLCanvasElement;
    this.canvas.width = this.W * this.dpr; this.canvas.height = this.H * this.dpr;
    this.canvas.style.width = `${this.W}px`; this.canvas.style.height = `${this.H}px`;
    this.ctx = this.canvas.getContext("2d") as CanvasRenderingContext2D;
    this.ctx.scale(this.dpr, this.dpr);
    this.canvas.addEventListener("mousedown", (e) => {
      const r = this.canvas.getBoundingClientRect();
      const [wx, wy] = this.toWorld(e.clientX - r.left, e.clientY - r.top);
      this.cb.onJump(wx, wy);
    });
  }

  private toMap(x: number, y: number): [number, number] {
    return [this.W / 2 + (x / this.span) * (this.W / 2), this.H / 2 + (y / this.span) * (this.H / 2)];
  }
  private toWorld(mx: number, my: number): [number, number] {
    return [((mx - this.W / 2) / (this.W / 2)) * this.span, ((my - this.H / 2) / (this.H / 2)) * this.span];
  }

  draw(cam: Camera, scene: SceneGraph) {
    if (!this.ctx) return;
    let s = 10;
    for (const n of scene.rt) s = Math.max(s, Math.abs(n.bx) + n.r, Math.abs(n.by) + n.r);
    this.span = s * 1.05;
    const ctx = this.ctx;
    ctx.clearRect(0, 0, this.W, this.H);
    for (const n of scene.rt) {
      if (n.tpl) continue;
      const [sx, sy] = this.toMap(n.bx, n.by);
      ctx.fillStyle = n.kind === "council" ? "#FFD700" : hexStr(this.color(n.gal));
      ctx.globalAlpha = n.kind === "note" ? 0.5 : 0.95;
      ctx.beginPath();
      ctx.arc(sx, sy, n.kind === "council" ? 3.2 : n.kind === "galaxy" ? 2 : 0.8, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    const halfW = cam.viewW / 2 / cam.z, halfH = cam.viewH / 2 / cam.z;
    const [x0, y0] = this.toMap(cam.x - halfW, cam.y - halfH);
    const [x1, y1] = this.toMap(cam.x + halfW, cam.y + halfH);
    ctx.strokeStyle = "rgba(255,255,255,.55)";
    ctx.lineWidth = 1;
    ctx.strokeRect(
      Math.max(0, x0), Math.max(0, y0),
      Math.min(this.W, x1) - Math.max(0, x0), Math.min(this.H, y1) - Math.max(0, y0),
    );
  }
}

function hexStr(n: number): string { return `#${n.toString(16).padStart(6, "0")}`; }
